/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_AlwaysInputs */

const vi_shop_home_always = /** @type {(inputs: Shop_Home_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luôn hiện`)
};

/**

* @param {Shop_Home_AlwaysInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_always = /** @type {((inputs?: Shop_Home_AlwaysInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_AlwaysInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_always(inputs)
});